/**
 * Geometry of the sourcing list card, in theme spacing steps. Shared by `Car`, its columns, the
 * title row and `CardStatsGrid`, so the card wraps consistently at every width.
 */
export const SOURCING_CARD_GEOMETRY = {
  /** Width of the image column while it sits beside the content (60 = 240px). */
  imageColumnWidth: 60,
  /** Below this content width (80 = 320px) it no longer fits beside the image and wraps under it. */
  contentMinWidth: 80,
  /**
   * The content takes practically all free space, so the image stays at its column width while both
   * fit on one row, yet the image can still grow to the full width once the content wraps below it.
   */
  contentGrow: 999,
  /** Below this title width (70 = 280px) the action buttons wrap under the title. */
  titleMinWidth: 70,
  /** Minimal width of one stat cell (20 = 80px), roughly the widest label. */
  statMinWidth: 20,
} as const;
